import { useHotkeys } from 'react-hotkeys-hook'
import { Stack } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { WorkflowState } from '@/types/workflows'
import Drawer from '@/components/drawer/Drawer'
import FlagsFilter from '@/components/filters/FlagsFilter'
import OrganizationsFilter from '@/components/filters/OrganizationsFilter'
import StateFilter from '@/components/filters/StateFilter'
import TagsFilter from '../filters/TagsFilter'
import AllFieldsFilter from './AllFieldsFilter'
import ViewsFilter from './ViewsFilter'

type ProjectTablesFilterDrawerProps = {
  overlay: OverlayState
  workflowStates: WorkflowState[]
  selectedWorkflowState?: WorkflowState
  setWorkflowState: (workflowStateId: string) => void
  // Optional
  showAllFields?: boolean
}

export default function ProjectTablesFilterDrawer({
  workflowStates,
  selectedWorkflowState,
  setWorkflowState,
  overlay,
  showAllFields,
}: ProjectTablesFilterDrawerProps) {
  useHotkeys('alt+l', () => overlay.toggle(), [overlay.toggle])

  return (
    <Drawer
      overlay={overlay}
      showToggleButton
      showMiniDrawer
      title="Filters"
      miniDrawerChildren={
        <Stack alignItems="center" sx={{ pt: 1 }}>
          <StateFilter
            workflowStates={workflowStates}
            selectedWorkflowState={selectedWorkflowState}
            setWorkflowState={setWorkflowState}
            miniMode
          />
        </Stack>
      }
    >
      <Stack p={2} spacing={3} sx={{ overflowY: 'auto' }}>
        <StateFilter
          workflowStates={workflowStates}
          selectedWorkflowState={selectedWorkflowState}
          setWorkflowState={setWorkflowState}
          showCount
        />
        <ViewsFilter />
        <AllFieldsFilter
          showAllFields={showAllFields}
          selectedWorkflowState={selectedWorkflowState}
        />
        <FlagsFilter hideNoFlags={!!showAllFields} />
        <TagsFilter />
        {/* <TeamsFilter /> */}
        <OrganizationsFilter />
      </Stack>
    </Drawer>
  )
}
